import { render, staticRenderFns } from "./MediaElement.global.vue?vue&type=template&id=3d13f822&"
import script from "./MediaElement.global.vue?vue&type=script&lang=js&"
export * from "./MediaElement.global.vue?vue&type=script&lang=js&"
import style0 from "./MediaElement.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports